/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Currency, defaultCurrency, useCurrencies } from '@zapier/currency';

import { Dropdown } from '@zapier/design-system-revenue/src/components/other';

import { FlagIcon } from './FlagIcon';

const rootStyles = css`
  width: 143px;
`;

type Props = {
  onSelectCurrency: (currency: Currency) => void;
  selectedCurrency: Currency;
};

/**
 * A dropdown that allows the user to select a currency to pay in.
 */
export const CurrencyDropdown = ({
  onSelectCurrency,
  selectedCurrency = defaultCurrency,
}: Props) => {
  const { isLoading, currencies: options, error } = useCurrencies();

  // Don't show if loading or error
  if (isLoading || error) {
    return null;
  }

  return (
    <div css={rootStyles}>
      <Dropdown
        ariaLabel="Currency"
        getLabelForSelectedItem={item => `${item.name} ${item.symbol}`}
        initialSelectedItem={selectedCurrency}
        items={options}
        menuAriaLabel="List of currencies"
        onChange={onSelectCurrency}
        placeholder="Choose a currency..."
        renderIcon={item => {
          return !!item && <FlagIcon name={item.icon} width={24} />;
        }}
      />
    </div>
  );
};
